import { Auth0ContextInterface } from "@auth0/auth0-react";
import { jwtDecode } from "jwt-decode";
import { Config } from "../../config";
const regionKey = "https://vpd.law/tenant_region";

export const getWebsocketUrl = async (auth0Context: Auth0ContextInterface): Promise<string> => {
  const token = await auth0Context.getAccessTokenSilently();
  const jwt = jwtDecode<{ [key: string]: any }>(token);

  if (regionKey in jwt && jwt[regionKey] === "SA") {
    return Config.saWsUrl || "";
  }

  return Config.wsUrl || "";
};
